export const PLAN_LIMITS = {
  gratuito: {
    receitasPerMonth: 1,
    despesasPerMonth: 10,
    metasTotal: 1,
    historyMonths: 3,
    customCategories: false,
    annualReport: false,
    pdfExport: false,
    projection12Month: false,
    receiptUpload: false,
  },
  platinum: {
    receitasPerMonth: Infinity,
    despesasPerMonth: Infinity,
    metasTotal: Infinity,
    historyMonths: Infinity,
    customCategories: true,
    annualReport: true,
    pdfExport: false,
    projection12Month: false,
    receiptUpload: false,
  },
  diamond: {
    receitasPerMonth: Infinity,
    despesasPerMonth: Infinity,
    metasTotal: Infinity,
    historyMonths: Infinity,
    customCategories: true,
    annualReport: true,
    pdfExport: true,
    projection12Month: true,
    receiptUpload: false,
  },
};

export function getPlanLimits(plan) {
  return PLAN_LIMITS[plan] || PLAN_LIMITS.gratuito;
}

export function canAddReceita(plan, currentCount) {
  const limits = getPlanLimits(plan);
  return currentCount < limits.receitasPerMonth;
}

export function canAddMeta(plan, currentCount) {
  const limits = getPlanLimits(plan);
  return currentCount < limits.metasTotal;
}

export function canAddDespesa(plan, currentCount) {
  const limits = getPlanLimits(plan);
  return currentCount < limits.despesasPerMonth;
}

export function canNavigateToMonth(plan, targetMes, targetAno) {
  const limits = getPlanLimits(plan);
  if (limits.historyMonths === Infinity) return true;
  const now = new Date();
  const currentTotal = now.getFullYear() * 12 + (now.getMonth() + 1);
  const targetTotal = targetAno * 12 + targetMes;
  const diff = targetTotal - currentTotal;
  return diff >= -(limits.historyMonths - 1) && diff <= 0;
}

export function canUseFeature(plan, feature) {
  const limits = getPlanLimits(plan);
  return !!limits[feature];
}

export function getRequiredPlan(feature) {
  if (PLAN_LIMITS.platinum[feature]) return 'platinum';
  if (PLAN_LIMITS.diamond[feature]) return 'diamond';
  return 'platinum';
}
